// extracted by mini-css-extract-plugin
export default {"drink_bar_expand":"DrinkBarExpand_drink_bar_expand__6jX9V","ingredient_bar":"DrinkBarExpand_ingredient_bar__JLoOf"};